// extracted by mini-css-extract-plugin
module.exports = {"container":"AddTransaction_container__2u0qQ"};